import moment from "moment";

export default function (date, template = "DD/MM/YYYY") {
  if (!date) {
    return template.replace(/[^/]/g, "-");
  }

  return moment(date).isValid() ? moment(date).format(template) : date;
}
